import React from 'react';

import {WithRouterProps} from 'react-router';

import {SPPage} from 'app/general/structures/SPPage';
import {CreateTeamForm} from 'app/teams/components/CreateTeamWidget';
import {getTeamDetailPageURL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {TeamSerializedType} from 'sweet-types';

export const TeamCreatePage = ({router}: WithRouterProps) => {
  const handleCreateTeam = (team: TeamSerializedType) =>
    router.push(getTeamDetailPageURL(team.id, team.slug));

  return (
    <SPPage
      title={gt('Create Team')}
      breadcrumbProps={{
        ct: 'team',
      }}
    >
      <CreateTeamForm
        isPopover={false}
        onCreateTeam={handleCreateTeam}
        showCancelButton={false}
      />
    </SPPage>
  );
};
